import styled from "@emotion/styled"
import { Text } from "@pallet-hq/hegel"

export const DiscountTag = ({ discount }: { discount: string }) => (
    <StyledText variant="uiSmall500">-{discount}</StyledText>
)

const StyledText = styled(Text)`
    padding: 4px;
    height: fit-content;
    background: rgba(0, 0, 0, 0.08);
    background-blend-mode: multiply;
    border-radius: 4px;
`
